// clients.jsx
import React from 'react';
import './clients.css';
import Sidebar from '../sidebar/sidebar';
import image from "../../assets/Large-screens/8.png"


const Clients = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
  );
};

export default Clients;
